import { debounce } from 'lodash';
import { memo } from 'react';
import useQueryParams from 'utils/hooks/useQueryParams';


const Search = ({ timeout = 500 , placeholder = 'Search here...' , label = '' , style}) => {
    const { setQueryParams } = useQueryParams();

    const handleInputChange = debounce((event) => {
        const value = event.target.value;
        setQueryParams({ keyword : value  , page : 1 })
    }, timeout );


    return (
        <div className='flex flex-col gap-2 flex-1 w-full'>
            {
                label && 
                <label className='font-semibold text-pure '>
                    {label} 
                </label>
            }
            <div 
            className={`
                box-shadow px-4 py-3 border border-lighter rounded-md sm:w-[300px] w-full flex items-center gap-4 focus-within:border-primary
                ${style}
            `}>
                <input 
                type="text" 
                placeholder={placeholder} 
                className='outline-none border-none bg-transparent flex-1'
                onChange={handleInputChange}
                />
                <i className="uil uil-search text-primary"></i>
            </div>
        </div>
    )
}

export default memo(Search)